class BlazeError extends Error {
  constructor(message, { code, priority, userId = null } = {}) {
    super(message);

    this.code = code;
    this.priority = priority;

    if (userId) {
      this.userId = userId;
    }
  }
}

module.exports = BlazeError;
